import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./App.css";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MilletsPage from "./pages/MilletsPage";
import MenuPage from "./pages/MenuPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import { useEffect } from "react";

export default function App() {
   const location = useLocation();

  useEffect(() => {
    window.gtag("config", "G-GLE702KBWC", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <>
      <Navbar />

      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/millets" element={<MilletsPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog/healthy-momos-hyderabad" element={<BlogPage />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
}